import React, { FC } from 'react';
import { CacheProvider as ActivityWallProvider } from '../../../../../../hooks/useCache';
import WallCardContainer from './WallCard.container';

interface Props {
  wallId: string;
  hidden?: boolean;
}

const WallCardProvider: FC<Props> = ({ hidden, ...props }) => {
  if (hidden) {
    return null;
  }

  return (
    <ActivityWallProvider>
      <WallCardContainer {...props} />
    </ActivityWallProvider>
  );
};

export default React.memo(WallCardProvider);
